"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalLocalizationProvider = void 0;
const react_1 = __importStar(require("react"));
const GlobalLocalizationContext_1 = require("./GlobalLocalizationContext");
const localization_context_1 = require("../../gatsby/localization-context/localization-context");
const localizationDataProvider = (locale) => require(`${__BOUTIK_MULTILOCALE_DATADIR__}/${locale}.json`);
const localizationContext = new localization_context_1.LocalizationContext(__BOUTIK_MULTILOCALE_DEFINITION__, localizationDataProvider);
const IS_SSR = typeof window === 'undefined';
// FIXME: Make this logic based on
if (typeof window !== 'undefined' &&
    typeof window.location.pathname === 'string') {
    const path = window.location.pathname;
    if (path.startsWith('/ca/fr/'))
        localizationContext.setLocale('fr_CA');
    else if (path.startsWith('/ca/en/'))
        localizationContext.setLocale('en_CA');
    else if (path.startsWith('/us/en/'))
        localizationContext.setLocale('en_US');
}
const GlobalLocalizationProvider = ({ children }) => {
    // This state is only used to trigger component refresh when locale change.
    const [, setLocaleChangeIncrement] = (0, react_1.useState)();
    const changeLocale = (0, react_1.useCallback)((locale) => {
        var _a;
        if (!localizationContext.i18next.isInitialized || IS_SSR) {
            localizationContext.setLocale(locale);
        }
        else if (locale !== ((_a = localizationContext.currentLocale) === null || _a === void 0 ? void 0 : _a.localeCode)) {
            // changeLocale may be called from inside the rendering of PageLocalizationProvider,
            // which would make the call to setState() in other components fail. To avoid these
            // issues, delay this call a little bit.
            Promise.resolve().then(() => {
                localizationContext.setLocale(locale);
                setLocaleChangeIncrement((current) => (current !== null && current !== void 0 ? current : 0) + 1);
            });
        }
    }, []);
    const contextValue = (0, react_1.useMemo)(() => {
        return {
            localizationContext,
            currentLocale: localizationContext.currentLocale,
            changeLocale,
        };
    }, [changeLocale]);
    return (react_1.default.createElement(GlobalLocalizationContext_1.GlobalLocalizationContext.Provider, { value: contextValue }, children));
};
exports.GlobalLocalizationProvider = GlobalLocalizationProvider;
//# sourceMappingURL=GlobalLocalizationProvider.js.map